import './footer.css';

function Footer(){
    return(
        <footer>
            <span>© Club ExDev 2025. Todos los derechos reservados - Av. José Pedro Alessandri 1242, Ñuñoa, Región Metropolitana</span>
        </footer>
    );
}
export default Footer;